import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "primary-container"
}
const _hoisted_2 = { class: "py-16 px-6 rounded-xl bg-white border border-gray-200" }
const _hoisted_3 = { class: "text-center mb-4" }
const _hoisted_4 = { class: "text-gray-900 font-medium text-2xl" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "text-center flex flex-row justify-center items-center flex-wrap mb-6" }
const _hoisted_7 = { class: "w-5 me-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

import { ref } from "vue";
import multipleSchoolsComponent from "./MultipleSchoolsComponent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateSchoolGroupComponent',
  setup(__props) {

const menuToggle = ref("");

// Function to show initial component
const showInitialComponent = () => {
    menuToggle.value = "";
}

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (menuToggle.value == '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('internal_tools.school_group.title')), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('internal_tools.school_group.sub_title')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (menuToggle.value = 'schoolGroup')),
                class: "font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white mt-4 mx-2 flex flex-row justify-center items-center flex-wrap"
              }, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-school-group',
                    title: 'rl school group',
                    "aria-hidden": "true"
                  })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('internal_tools.school_group.btn_multiple')), 1)
              ])
            ]),
            _hoisted_8
          ])
        ]))
      : _createCommentVNode("", true),
    (menuToggle.value == 'schoolGroup')
      ? (_openBlock(), _createBlock(multipleSchoolsComponent, {
          key: 1,
          onUpdateValue: showInitialComponent
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})